module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/companies/company-inventory/modal-add-contract-type/add-contract-type.component.scss
// module id = ./src/app/views/companies/company-inventory/modal-add-contract-type/add-contract-type.component.scss
// module chunks = main